module.exports = new __parcel__URL__("oldEditorImage.very-specific-illu.cd2f1dd1.png").toString();